module.exports = __webpack_public_path__ + "img/free-trial-icon.2c8caf38.svg";